module.exports = __webpack_public_path__ + "static/media/lAlexander.99813b09.jpeg";